import React from "react"
import {
  flexBox,
  MEDIA_BREAKPOINT_KEYS,
  responsiveFontSize,
  WINDOW_MEDIA_QUERIES,
} from "style/style_snippets"
import { alpha } from '@mui/material/styles';

import { useTheme } from "@mui/material"
import Container from "@mui/material/Container"
import Button from "@mui/material/Button"
import { DISCLAIMER_TABS } from "components/Disclaimer/Disclaimer"

const Footer = ({ setDisclaimerOpenTab }) => {
  const theme = useTheme()

  const {
    palette: { grey },
  } = theme

  const footerStyle = {
    container: {
      paddingTop: 40,
      paddingBottom: 40,
      color: "white",
    },

    wrapper: {
      borderTop: `1px solid ${alpha(grey["500"], 0.3)}`,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "center",
      paddingTop: ".5rem",

      [WINDOW_MEDIA_QUERIES[MEDIA_BREAKPOINT_KEYS.sm]]: {
        flexDirection: "row-reverse",
        paddingTop: "1.5rem",
      },
    },

    links: {
      fontWeight: 300,
      textTransform: "capitalize",
      color: "white",
      fontSize: responsiveFontSize(14, 16),
      ...flexBox.column,
      justifyContent: "center",
      alignItems: "center",
      marginBottom: "2rem",
      button: {
        marginBottom: ".5rem",
      },
      "&.button:not(:last-of-type)": {
        marginBottom: "0",
      },

      "button:hover": {
        color: theme.palette.primary.main,
      },

      [WINDOW_MEDIA_QUERIES[MEDIA_BREAKPOINT_KEYS.sm]]: {
        flexDirection: "row",
        marginBottom: "0",
        button: {
          marginBottom: "0",
          marginLeft: "20px",
        },
      },
    },
    description: {
      textAlign: "center",
    },
  }

  return (
    <Container maxWidth={"xl"} disableGutters css={footerStyle.container}>
      <Container maxWidth={"xl"} css={footerStyle.wrapper}>
        <div css={footerStyle.links}>
          <Button
            variant={"text"}
            color={"secondary"}
            onClick={() => setDisclaimerOpenTab(DISCLAIMER_TABS.PROVIDER.index)}
          >
            Provider
          </Button>

          <Button
            variant={"text"}
            color={"secondary"}
            onClick={() =>
              setDisclaimerOpenTab(DISCLAIMER_TABS.LEGAL_NOTICES.index)
            }
          >
            Legal Notice
          </Button>

          <Button
            variant={"text"}
            color={"secondary"}
            onClick={() =>
              setDisclaimerOpenTab(DISCLAIMER_TABS.PRIVACY_STATEMENT.index)
            }
          >
            Privacy Statement
          </Button>

          <Button
            variant={"text"}
            color={"secondary"}
            onClick={() =>
              setDisclaimerOpenTab(DISCLAIMER_TABS.CREDITS.index)
            }
          >
            Credits
          </Button>
        </div>

        <div css={footerStyle.description}>
          © Mercedes-Benz AG. This is the Open Source
          website of Mercedes-Benz AG
        </div>
      </Container>
    </Container>
  )
}

export default Footer
